/**
 * Utilitário central para controle das fases do concurso.
 * Toda a lógica baseada na fase deve passar por aqui.
 *
 * Valores possíveis de fase:
 *   pre-concurso   → Home exibe contador regressivo
 *   1              → Fase 1 ativa (votação por categorias)
 *   1-encerrada    → Fase 1 encerrada
 *   2              → Fase 2 ativa (votação por padarias finalistas)
 *   2-encerrada    → Fase 2 encerrada
 *   3              → Resultado final divulgado
 */

import resolverCidadeSlug from './cidadeAtiva';

export const FASES = {
  PRE_CONCURSO: 'pre-concurso',
  FASE_1: '1',
  FASE_1_ENCERRADA: '1-encerrada',
  FASE_2: '2',
  FASE_2_ENCERRADA: '2-encerrada',
  FASE_3: '3'
};

// Configuração das datas das fases (Formato ISO: YYYY-MM-DDTHH:mm:ss-03:00 para horário de Brasília)
export const DATAS_FASES_SP = {
  INICIO_FASE_1: new Date(process.env.REACT_APP_DATA_INICIO_FASE_1_SP),
  FIM_FASE_1: new Date(process.env.REACT_APP_DATA_FIM_FASE_1_SP),
  INICIO_FASE_2: new Date(process.env.REACT_APP_DATA_INICIO_FASE_2_SP),
  FIM_FASE_2: new Date(process.env.REACT_APP_DATA_FIM_FASE_2_SP)
};

export const DATAS_FASES_BH = {
  INICIO_FASE_1: new Date(process.env.REACT_APP_DATA_INICIO_FASE_1_BH),
  FIM_FASE_1: new Date(process.env.REACT_APP_DATA_FIM_FASE_1_BH),
  INICIO_FASE_2: new Date(process.env.REACT_APP_DATA_INICIO_FASE_2_BH),
  FIM_FASE_2: new Date(process.env.REACT_APP_DATA_FIM_FASE_2_BH)
};

// Mantido para retrocompatibilidade (retorna SP por padrão)
export const DATAS_FASES = DATAS_FASES_SP;

export const getDatasFases = (cidade) => {
  const slug = resolverCidadeSlug(cidade);
  if (slug === 'belo-horizonte') {
    return DATAS_FASES_BH;
  }
  return DATAS_FASES_SP;
};

export const getFase = (cidade) => {
  const faseEnv = process.env.REACT_APP_FASE;
  if (faseEnv === FASES.FASE_3) {
    return FASES.FASE_3;
  }
  // Se quiser forçar a fase do .env, descomentar abaixo:
  // if (faseEnv) return faseEnv;

  const datas = getDatasFases(cidade);
  const agora = new Date();

  if (agora < datas.INICIO_FASE_1) {
    return FASES.PRE_CONCURSO;
  }

  if (agora < datas.FIM_FASE_1) {
    return FASES.FASE_1;
  }

  if (agora < datas.INICIO_FASE_2) {
    return FASES.FASE_1_ENCERRADA;
  }

  if (agora < datas.FIM_FASE_2) {
    return FASES.FASE_2;
  }

  // Após o fim da fase 2, fica como fase 2 encerrada até alguém setar Fase 3 no .env
  return FASES.FASE_2_ENCERRADA;
};

export const isPreConcurso = (cidade) => getFase(cidade) === FASES.PRE_CONCURSO;

export const exibeSeletorCidade = () =>
  !isPreConcurso('sao-paulo') || !isPreConcurso('belo-horizonte');

export const isFase1Ativa = (cidade) => getFase(cidade) === FASES.FASE_1;

export const isFase1Encerrada = (cidade) =>
  [
    FASES.FASE_1_ENCERRADA,
    FASES.FASE_2,
    FASES.FASE_2_ENCERRADA,
    FASES.FASE_3
  ].includes(getFase(cidade));

export const isFase2Ativa = (cidade) => getFase(cidade) === FASES.FASE_2;

export const isFase2Encerrada = (cidade) =>
  [FASES.FASE_2_ENCERRADA, FASES.FASE_3].includes(getFase(cidade));

export const isResultadoFinal = (cidade) => getFase(cidade) === FASES.FASE_3;

export const exibeBotaoVotar = (cidade) =>
  [FASES.FASE_1, FASES.FASE_2].includes(getFase(cidade));

export const exibeCategoriasFase1 = (cidade) =>
  getFase(cidade).charAt(0) === '1';

export const exibePadariasFase2 = (cidade) =>
  [FASES.FASE_2, FASES.FASE_2_ENCERRADA].includes(getFase(cidade));
